// Fonte única dos nomes de cargo exibidos na tela. Antes cada tela tinha sua
// própria cópia (Topbar, Perfil, Usuários, Tarefas, Admin) e várias caíam em
// "Vendedor" para qualquer cargo que não conheciam — o Perfil mostrava
// "Vendedor" até para o CEO.

export const ROLE_LABELS: Record<string, string> = {
  ceo: 'CEO',
  gestor: 'Gestor',
  vendedor: 'Vendedor',
  sdr: 'SDR',
  cs: 'CS',
  navegador: 'Navegador',
  operacao: 'Operação',
  admin: 'Admin',
  superadmin: 'Superadmin',
};

/** Nome do cargo para exibir. Cargo desconhecido aparece como veio, nunca como outro cargo. */
export function getRoleLabel(role: string | null | undefined): string {
  const key = role?.toLowerCase().trim() ?? '';
  if (!key) return '';
  return ROLE_LABELS[key] ?? key.charAt(0).toUpperCase() + key.slice(1);
}
